import React, { useEffect, useMemo, useState } from 'react';
import { collection, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { db } from '../../Admin/Config/Config';

const ScrollingTextBox = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
   
    const q = query(
      collection(db, 'scrollNews'),
      where('active', '==', true),
      orderBy('createdAt', 'desc')
    );

    // Track possible fallback unsub
    let fallbackUnsub = null;

    const unsub = onSnapshot(
      q,
      (snap) => {
        const next = snap.docs
          .map((d) => d.data())
          .map((d) => (typeof d?.text === 'string' ? d.text.trim() : ''))
          .filter(Boolean);
        setItems(next);
        setLoading(false);
      },
      (err) => {
        console.error('[scrollNews] query failed, falling back to unfiltered listener:', err);
        // Fallback: simple collection listener without where/order (no index required)
        fallbackUnsub = onSnapshot(
          collection(db, 'scrollNews'),
          (snap2) => {
            const next2 = snap2.docs
              .map((d) => d.data())
              .map((d) => (typeof d?.text === 'string' ? d.text.trim() : ''))
              .filter(Boolean);
            setItems(next2);
            setLoading(false);
          },
          (err2) => {
            console.error('[scrollNews] fallback listener failed:', err2);
            setLoading(false);
          }
        );
      }
    );

    return () => {
      unsub();
      if (fallbackUnsub) fallbackUnsub();
    };
  }, []);

  const display = useMemo(() => {
    if (loading) {
      return [
        'Loading latest updates…',
      ];
    }
    if (!items.length) {
      return [
        'No announcements right now. Check back soon!'
      ];
    }
    return items;
  }, [items, loading]);

  return (
    <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-8 flex items-center justify-center">
      <div className="max-w-7xl w-full">
        {/* Red line header */}
        <div className="h-1 bg-gradient-to-r from-red-500 to-red-600 rounded-t mb-1"></div>
        
        {/* Single Scrolling Text Box */}
        <div className="bg-white border border-gray-200 shadow-xl rounded-xl overflow-hidden backdrop-blur-sm">
          {/* Scrolling Content */}
          <div className="px-6 py-4 overflow-hidden">
            <div className="whitespace-nowrap text-gray-700 text-lg font-medium animate-scroll">
              {display.map((item, index) => (
                <span key={index} className="mx-4">{item} •</span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Custom CSS for scrolling animation */}
      <style jsx>{`
        @keyframes scroll {
          0% { 
            transform: translateX(0); 
          }
          100% { 
            transform: translateX(-50%); 
          }
        }
        
        .animate-scroll {
          animation: scroll 20s linear infinite;
          display: inline-block;
        }
        
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default ScrollingTextBox;